import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'

export default createUseStyles({
  text: {
    ...typography['Lato H5 Bold'],
    textAlign: 'center',
    marginTop: '20vh',
    padding: '0 60px',
  },
})
